module.exports = __webpack_public_path__ + "img/FLECHE_DROITE_DESACTIVE.7c5c28e9.svg";